import AppLayout from '@/layout/AppLayout.vue';
import HomePage from '@/views/HomePage.vue';
import MainPage from '@/views/MainPage.vue';
import ObligationsCalendar from '@/views/ObligationsCalendar.vue';
import Access from '@/views/pages/auth/Access.vue';
import Auth from '@/views/pages/auth/Auth.vue';
import Error from '@/views/pages/auth/Error.vue';
import Login from '@/views/pages/auth/Login.vue';
import { createRouter, createWebHistory } from 'vue-router';

const isAuthenticated = () => {
    const user = localStorage.getItem('user');
    const token = localStorage.getItem('token');
    return !!user && !!token;
  };

const isTokenValid = (token) => {
    if (!token) return false;
  
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      const exp = payload.exp; // expiration time in seconds
      const now = Date.now() / 1000; // current time in seconds
  
      return exp > now;
    } catch (e) {
      console.error('Invalid token', e);
      return false;
    }
};

const reauthenticate = (to, from, next) => {
    if (!isAuthenticated() || !isTokenValid(localStorage.getItem('token'))) {
        next({ name: 'login' });
    } else {
        next();
    }
}

const router = createRouter({
    history: createWebHistory(),
    routes: [
        {
            path: '/',
            component: AppLayout,
            children: [
                {
                    path: '/',
                    name: 'home',
                    component: HomePage,
                    beforeEnter: reauthenticate
                },
                {
                    path: '/uikit/formlayout',
                    name: 'formlayout',
                    component: () => import('@/views/uikit/FormLayout.vue')
                },
                {
                    path: '/uikit/input',
                    name: 'input',
                    component: () => import('@/views/uikit/InputDoc.vue')
                },
                {
                    path: '/uikit/button',
                    name: 'button',
                    component: () => import('@/views/uikit/ButtonDoc.vue')
                },
                {
                    path: '/uikit/table',
                    name: 'table',
                    component: () => import('@/views/uikit/TableDoc.vue')
                },
                {
                    path: '/uikit/list',
                    name: 'list',
                    component: () => import('@/views/uikit/ListDoc.vue')
                },
                {
                    path: '/uikit/tree',
                    name: 'tree',
                    component: () => import('@/views/uikit/TreeDoc.vue')
                },
                {
                    path: '/uikit/panel',
                    name: 'panel',
                    component: () => import('@/views/uikit/PanelsDoc.vue')
                },

                {
                    path: '/uikit/overlay',
                    name: 'overlay',
                    component: () => import('@/views/uikit/OverlayDoc.vue')
                },
                {
                    path: '/uikit/media',
                    name: 'media',
                    component: () => import('@/views/uikit/MediaDoc.vue')
                },
                {
                    path: '/uikit/message',
                    name: 'message',
                    component: () => import('@/views/uikit/MessagesDoc.vue')
                },
                {
                    path: '/uikit/file',
                    name: 'file',
                    component: () => import('@/views/uikit/FileDoc.vue')
                },
                {
                    path: '/uikit/menu',
                    name: 'menu',
                    component: () => import('@/views/uikit/MenuDoc.vue')
                },
                {
                    path: '/uikit/charts',
                    name: 'charts',
                    component: () => import('@/views/uikit/ChartDoc.vue')
                },
                {
                    path: '/uikit/misc',
                    name: 'misc',
                    component: () => import('@/views/uikit/MiscDoc.vue')
                },
                {
                    path: '/uikit/timeline',
                    name: 'timeline',
                    component: () => import('@/views/uikit/TimelineDoc.vue')
                },
                {
                    path: '/pages/empty',
                    name: 'empty',
                    component: () => import('@/views/pages/Empty.vue')
                },
                {
                    path: '/pages/crud',
                    name: 'crud',
                    component: () => import('@/views/pages/Crud.vue')
                },
                {
                    path: '/documentation',
                    name: 'documentation',
                    component: () => import('@/views/pages/Documentation.vue')
                }
            ]
        },
        {
            path: '/landing',
            name: 'landing',
            component: () => import('@/views/pages/Landing.vue')
        },
        {
            path: '/pages/notfound',
            name: 'notfound',
            component: () => import('@/views/pages/NotFound.vue')
        },

        {
            path: '/auth/login',
            name: 'login',
            component: Login
        },
        {
            path: '/auth/authenticate',
            name: 'authenticate',
            component: Auth
        },
        {
            path: '/auth/access',
            name: 'accessDenied',
            component: Access
        },
        {
            path: '/auth/error',
            name: 'error',
            component: Error
        },
        {
            path: '/sidebar/:menuItem',
            name: 'MainPage',
            component: MainPage,
            beforeEnter: reauthenticate,
            props: true,
        },
        {
            path: '/obligations-calendar',
            name: 'obligationsCalendar',
            component: ObligationsCalendar,
            beforeEnter: reauthenticate,
        }
    ]
});

export default router;
